import React, { useMemo } from 'react';
import { buildWhatsAppUrl } from '../../lib/attribution';
import { CONTACT_CHANNELS, WHATSAPP_NUMBER } from '../../lib/analytics.constants';
import { trackEvent } from '../../lib/analytics';

export default function WhatsAppLink({
  ctaId,
  ctaLocation,
  message,
  modelName,
  className,
  children,
  onClick,
  number = WHATSAPP_NUMBER,
  ...props
}) {
  const href = useMemo(
    () => buildWhatsAppUrl({ number, message, ctaId }),
    [number, message, ctaId]
  );

  const handleClick = (event) => {
    trackEvent('whatsapp_click', {
      cta_id: ctaId,
      cta_location: ctaLocation,
      contact_channel: CONTACT_CHANNELS.WHATSAPP,
      wa_number: number,
      ...(modelName ? { model_name: modelName } : {}),
    });
    onClick?.(event);
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  );
}
